<template>
  <div style="padding-top: 10%;font-size: 14px;font-weight: bold">
    <div style="padding: 0px 30px">
      <van-tag round type="danger"  size="large">移动端上课方式</van-tag>
      <div style="padding-top: 10px">微信扫描二维码下载"在线课堂"APP或手机软件商城</div>
    </div>
    <van-row type="flex" justify="space-around" style="padding-top: 20px">
      <van-col  span="8">
        <van-image fit="contain" width="100%" height="100%" src="/minio/gyfw/school/中共/AndroidApp.jpg"/>
      </van-col>
      <van-col  span="8">
        <van-image fit="contain" width="100%" height="100%" src="/minio/gyfw/school/中共/iosApp.jpg"/>
      </van-col>
    </van-row>
    <div style="padding: 30px 30px 0px">
      <van-tag round type="danger"  size="large">电脑端上课方式</van-tag>
      <div style="padding-top: 10px">登录<a style="color: orange" href="https://e.eoffcn.com" target="_blank">e.eoffcn.com</a></div>
      <div>进入【我的课程】-找到课程 【展开】-学习</div>
    </div>
  </div>

</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>
